import React, { useState } from 'react';
import { FiGrid, FiList, FiSearch, FiChevronRight } from 'react-icons/fi';

const allProducts = [
  // Air Insulated Switchgear
  {
    id: 1,
    name: 'AIS Circuit Breaker Panel 24kV',
    category: 'Air Insulated Switchgear',
    voltage: '24kV',
    current: '630A',
    image: 'AIS CB 24kV Panel',
    description: 'Panel switchgear medium voltage dengan Circuit Breaker Vacuum, cocok untuk aplikasi indoor.',
    price: 'Request Quote'
  },
  {
    id: 2,
    name: 'AIS LBS Motorized Panel 24kV',
    category: 'Air Insulated Switchgear',
    voltage: '24kV',
    current: '630A',
    image: 'AIS LBS 24kV Panel',
    description: 'Switchgear AIS 24kV dengan load break switch motorized untuk distribusi daya.',
    price: 'Request Quote'
  },
  {
    id: 3,
    name: 'AIS LBS Manual Panel 24kV',
    category: 'Air Insulated Switchgear',
    voltage: '24kV',
    current: '630A',
    image: 'AIS LBS 24kV Panel',
    description: 'High voltage AIS panel dengan proteksi lengkap dan sistem interlocking.',
    price: 'Request Quote'
  },
  {
    id: 4,
    name: 'AIS Metering Panel 24kV',
    category: 'Air Insulated Switchgear',
    voltage: '24kV',
    current: '630A',
    image: 'AIS Metering 24kV Panel',
    description: 'Medium Voltage AIS dilengkapi dengan Voltage Transformer untuk kemampuan metering',
    price: 'Request Quote'
  },
  {
    id: 5,
    name: 'AIS Transformer Protection 24kV',
    category: 'Air Insulated Switchgear',
    voltage: '24kV',
    current: '630A',
    image: 'AIS TP 24kV Panel',
    description: 'Air Insulated Switchgear dengan fungsi khusus untuk melindungi transformer dari gangguan power',
    price: 'Request Quote'
  },
  // Gas Insulated Switchgear
  {
    id: 6,
    name: 'GIS RMU Circuit Breaker 24kV',
    category: 'Gas Insulated Switchgear',
    voltage: '24kV',
    current: '630A',
    image: 'GIS RMU CB 24kV Panel',
    description: 'Ring Main Unit terisolasi gas SF6 untuk jaringan distribusi dengan circuit breaker.',
    price: 'Request Quote'
  },
  {
    id: 7,
    name: 'GIS RMU LBS Motorized 24kV',
    category: 'Gas Insulated Switchgear',
    voltage: '24kV',
    current: '630A',
    image: 'GIS RMU LBS Motorized 24kV Panel',
    description: 'GIS dengan gas SF6 untuk kebutuhan RMU dengan ruang terbatas.',
    price: 'Request Quote'
  },
  {
    id: 8,
    name: 'GIS RMU LBS Manual 24kV',
    category: 'Gas Insulated Switchgear',
    voltage: '24kV',
    current: '630A',
    image: 'GIS RMU LBS Manual 24kV Panel',
    description: 'GIS Medium Voltage dengan kemampuan handal dalam sistem proteksi.',
    price: 'Request Quote'
  },
  {
    id: 9,
    name: 'GIS RMU Metering 24kV',
    category: 'Gas Insulated Switchgear',
    voltage: '24kV',
    current: '630A',
    image: 'GIS RMU Metering 24kV Panel',
    description: 'GIS dengan dilengkapi voltage transformer untuk menunjang fungsi metering',
    price: 'Request Quote'
  },
  {
    id: 10,
    name: 'GIS RMU Transformer Protection 24kV',
    category: 'Gas Insulated Switchgear',
    voltage: '24kV',
    current: '630A',
    image: 'GIS RMU TP 24kV Panel',
    description: 'GIS Medium Voltage menggunakan Fuse untuk melindungi Transformer dari gangguan.',
    price: 'Request Quote'
  },
  // Metal Clad
  {
    id: 11,
    name: 'Metal Clad Incoming 24kV',
    category: 'Metal Clad',
    voltage: '24kV',
    current: '650A',
    image: 'Metal Clad Incoming 24kV',
    description: 'Metal-enclosed switchgear dengan kompartemen terpisah untuk keamanan maksimal.',
    price: 'Request Quote'
  },
  {
    id: 12,
    name: 'Metal Clad Outgoing 24kV',
    category: 'Metal Clad',
    voltage: '24kV',
    current: '650A',
    image: 'Metal Clad Outgoing 24kV',
    description: 'Heavy-duty metal clad switchgear untuk aplikasi industri berat.',
    price: 'Request Quote'
  },
  {
    id: 13,
    name: 'Metal Clad Coupler 24kV',
    category: 'Metal Clad',
    voltage: '24kV',
    current: '2500A',
    image: 'Metal Clad 24kV',
    description: 'Premium metal clad panel dengan arc resistance dan sistem proteksi canggih.',
    price: 'Request Quote'
  }
];

const categories = [
  { name: 'All Products', count: 13 },
  { name: 'Air Insulated Switchgear', count: 5 },
  { name: 'Gas Insulated Switchgear', count: 5 },
  { name: 'Metal Clad', count: 3 }
];

const voltageOptions = ['24kV', '36kV'];

const Products = ({ onProductClick }) => {
  const [selectedCategory, setSelectedCategory] = useState('All Products');
  const [selectedVoltages, setSelectedVoltages] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [viewMode, setViewMode] = useState('grid');

  const handleVoltageChange = (voltage) => {
    setSelectedVoltages(prev =>
      prev.includes(voltage)
        ? prev.filter(v => v !== voltage)
        : [...prev, voltage]
    );
  };

  const filteredProducts = allProducts.filter(product => {
    const matchCategory = selectedCategory === 'All Products' || product.category === selectedCategory;
    const matchVoltage = selectedVoltages.length === 0 || selectedVoltages.includes(product.voltage);
    const matchSearch = product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                       product.description.toLowerCase().includes(searchQuery.toLowerCase());
    return matchCategory && matchVoltage && matchSearch;
  });

  return (
    <div className="products-page">
      {/* Page Header */}
      <div className="page-header">
        <div className="container">
          <div className="page-header-content">
            <span className="page-subtitle">Our Products</span>
            <h1 className="page-title">Medium Voltage Switchgear</h1>
            <div className="breadcrumb">
              <a href="#home">Home</a>
              <FiChevronRight />
              <span>Products</span>
            </div>
          </div>
        </div>
      </div>

      {/* Products Section */}
      <section className="products-section section">
        <div className="container">
          <div className="products-layout">
            {/* Sidebar Filter */}
            <aside className="products-sidebar">
              {/* Search */}
              <div className="sidebar-widget">
                <h3 className="widget-title">Search</h3>
                <div className="search-box">
                  <input
                    type="text"
                    placeholder="Search products..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <FiSearch className="search-icon" />
                </div>
              </div>

              {/* Categories */}
              <div className="sidebar-widget">
                <h3 className="widget-title">Categories</h3>
                <ul className="category-list">
                  {categories.map((cat) => (
                    <li
                      key={cat.name}
                      className={selectedCategory === cat.name ? 'active' : ''}
                      onClick={() => setSelectedCategory(cat.name)}
                    >
                      <span className="cat-name">{cat.name}</span>
                      <span className="cat-count">{cat.count}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Voltage Filter */}
              <div className="sidebar-widget">
                <h3 className="widget-title">Voltage Rating</h3>
                <ul className="filter-list">
                  {voltageOptions.map((voltage) => (
                    <li key={voltage}>
                      <label className="checkbox-label">
                        <input
                          type="checkbox"
                          checked={selectedVoltages.includes(voltage)}
                          onChange={() => handleVoltageChange(voltage)}
                        />
                        <span className="checkmark"></span>
                        <span>{voltage}</span>
                      </label>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Contact CTA */}
              <div className="sidebar-widget sidebar-cta">
                <h3>Need Help?</h3>
                <p>Hubungi tim kami untuk konsultasi produk yang sesuai dengan kebutuhan Anda.</p>
                <a href="#contact" className="btn btn-primary">Contact Us</a>
              </div>
            </aside>

            {/* Products Grid */}
            <div className="products-main">
              {/* Toolbar */}
              <div className="products-toolbar">
                <div className="toolbar-left">
                  <p>Showing <strong>{filteredProducts.length}</strong> products</p>
                </div>
                <div className="toolbar-right">
                  <div className="view-toggle">
                    <button
                      className={viewMode === 'grid' ? 'active' : ''}
                      onClick={() => setViewMode('grid')}
                    >
                      <FiGrid />
                    </button>
                    <button
                      className={viewMode === 'list' ? 'active' : ''}
                      onClick={() => setViewMode('list')}
                    >
                      <FiList />
                    </button>
                  </div>
                </div>
              </div>

              {/* Products Grid */}
              <div className={`products-grid ${viewMode}`}>
                {filteredProducts.map((product) => (
                  <div
                    className="product-card"
                    key={product.id}
                    onClick={() => onProductClick && onProductClick(product)}
                  >
                    <div className="product-image">
                      <span className="product-category-tag">{product.category}</span>
                      <div className="product-image-placeholder">
                        {product.image}
                      </div>
                    </div>
                    <div className="product-info">
                      <h3 className="product-name">{product.name}</h3>
                      <p className="product-description">{product.description}</p>
                      <div className="product-specs">
                        <span className="spec">
                          <strong>Voltage:</strong> {product.voltage}
                        </span>
                        <span className="spec">
                          <strong>Current:</strong> {product.current}
                        </span>
                      </div>
                      <div className="product-footer">
                        <span className="product-price">{product.price}</span>
                        <button className="btn-view-detail">View Details</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {/* No Results */}
              {filteredProducts.length === 0 && (
                <div className="no-results">
                  <h3>No products found</h3>
                  <p>Try adjusting your filters or search query.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
